import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=17184e24&scoped=true"
import script from "./CollectionsList.vue?vue&type=script&lang=js"
export * from "./CollectionsList.vue?vue&type=script&lang=js"
import style0 from "./CollectionsList.vue?vue&type=style&index=0&id=17184e24&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17184e24",
  null
  
)

export default component.exports